import { useAppSelector } from "../hooks/reduxHooks";
import { ILocalStorageUserData } from "../types/users";

export const useAuthenticatedUser = (): NonNullable<
    ILocalStorageUserData["user"]
> => {
    const user = useAppSelector(state => state.auth.user);

    if (!user) {
        throw new Error("User is not defined");
    }

    return user;
};
